/**
 * Returns true if the value is not null or undefined (and narrows the corresponding type)
 *
 * @param value any value
 * @returns true if the value is not null or undefined
 */
export const isDefined = (value) => value != null;
//# sourceMappingURL=isDefined.js.map